<h3 mat-dialog-title class="lt title" [ngClass]="{ error: reference.isError }">{{ reference.title | translate }}</h3>
<mat-dialog-content>
    <p *ngFor="let message of reference.messages">{{ message | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button [color]="reference.isError ? 'warn' : 'accent'"  mat-dialog-close>{{ 'LABEL.OK' | translate }}</button>
</mat-dialog-actions>